export const APP_VERSION = __DECHESS_VERSION__;
export const APP_RELEASE_DATE = __DECHESS_RELEASE_DATE__;
